// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1d1yT","header":"MergedInvoice_header__1XgMd"};